export const blockIconsHomePropane = (
	<span className='material-symbols-outlined'>propane</span>
);
